import { render } from "./GlobalChatBubble.vue?vue&type=template&id=2c19f4c1&scoped=true"
import script from "./GlobalChatBubble.vue?vue&type=script&lang=js"
export * from "./GlobalChatBubble.vue?vue&type=script&lang=js"

import "./GlobalChatBubble.vue?vue&type=style&index=0&id=2c19f4c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c19f4c1"]])

export default __exports__